/**
 * @file CustomSelectTable.tsx
 * @module app/custom/Select/CustomSelectTable
 * @description Renders the CustomSelectTable reusable select control, including option presentation, creation, multi-selection, and table-filter behavior.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import Select from 'react-select';
import { useThemeMode } from '../../../_admin/partials';
const CustomSelectTable = (props: any) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  return (
    <>
      <Select
        // isDisabled={props.isDisabled}
        // menuPosition={'fixed'}
        // menuIsOpen={true}
        hideSelectedOptions={false}
        controlShouldRenderValue={false}
        onMenuClose={props.onMenuClose}
        onMenuOpen={props.onMenuOpen}
        openMenuOnClick={props.openMenuOnClick}
        placeholder={props.placeholder}
        defaultValue={props.default}
        isLoading={props.isLoading}
        onMenuScrollToBottom={props.onMenuScrollToBottom}
        menuPortalTarget={document.body}
        onChange={props.onChange}
        isDisabled={props.options ? props.options.length === 0 : true}
        options={props.options}
        isOptionDisabled={props.isOptionDisabled}
        menuPlacement={'bottom'}
        styles={{
          option: (base:any) => ({
            ...base,
            borderBottom: `2px solid ${isDark ? '#2b3a52' : '#e0e0df'}`,
            ':last-child': {
              borderBottom: 'none',
            },
            margin: '0px',
            background: isDark ? '#16213a' : '#fff',
            padding: '0px',
            boxShadow: isDark ? '0 0 0 1px #16213a' : '0 0 0 1px white',
            ':active': {
              ...base[':active'],
              backgroundColor: isDark ? '#1e293b' : 'white',
            },
            ':hover': {
              ...base[':active'],
              backgroundColor: isDark ? '#1e293b' : 'white',
            },
            color: isDark ? '#e2e8f0' : '#5e6278',
            fontSize: '1.077rem',
            fontWeight: '600',
          }),
          control: (base:any) => ({
            ...base,
            border: 'none',
            borderColor: 'transparent',
            boxShadow: 'none',
            backgroundColor: props.backgroundColor
              ? props.backgroundColor
              : (isDark ? '#16213a' : '#f9f9f9'),
            cursor: 'pointer',
            '&:active': {
              border: 'none',
              // display: 'none',
              borderColor: 'transparent',
              backgroundColor: props.backgroundColor
                ? props.backgroundColor
                : (isDark ? '#1e293b' : '#f9f9f9'),
              boxShadow: 'none',
            },
            '&:hover': {
              border: 'none',
              // display: 'none',
              backgroundColor: props.backgroundColor
                ? props.backgroundColor
                : (isDark ? '#1e293b' : '#f9f9f9'),
              boxShadow: 'none',
            },
          }),
          menu: (base:any) => ({
            ...base,
            boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.1)',
            backgroundColor: isDark ? '#16213a' : '#fff',
            zIndex: '999',
            marginLeft: props.menuMargin ? props.menuMargin : base.marginLeft,
          }),
          menuList: (base:any) => ({
            ...base,
            paddingTop: '0px',
            paddingBottom: '0px',
            borderRadius: '5px',
            width: props.width ? props.width : '160px',
            marginLeft: props.marginLeft,
          }),
          menuPortal: (base:any, props:any) => ({
            ...base,
            zIndex: 9999,
          }),
          indicatorSeparator: (base:any) => ({
            ...base,
            display: 'none',
          }),
          indicatorsContainer: (base:any) => ({
            ...base,
            display: 'none',
          }),
          multiValueRemove: (base:any, { data }:any) => ({
            ...base,
            height: '12px',
            ':hover': {
              backgroundColor: '#e7f1fd',
            },
            svg: {
              height: '22px',
              width: '22px',
              fill: '#7c7c7c',
            },
          }),
          multiValue: (base:any) => ({
            ...base,
            backgroundColor: '#e0e0df',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px 5px 10px 10px',
            borderRadius: '6px',
            fontSize: '16px',
            fontWeight: '600',
            height: '30px',
            width: 'auto',
          }),
          multiValueLabel: (base:any) => ({
            fontSize: '1.077rem',
            fontWeight: '600',
          }),
        }}
        isSearchable={false}
        isMulti={props.isMulti}
      />
    </>
  );
};
export { CustomSelectTable };
